__turbopack_context__.v({
  "Backdrop": "MegaMenu-module-scss-module__A1C2Vq__Backdrop",
  "Content": "MegaMenu-module-scss-module__A1C2Vq__Content",
  "ContentContainer": "MegaMenu-module-scss-module__A1C2Vq__ContentContainer",
  "ContentFeatureLeft": "MegaMenu-module-scss-module__A1C2Vq__ContentFeatureLeft",
  "Divider": "MegaMenu-module-scss-module__A1C2Vq__Divider",
  "FeatureCard--wide": "MegaMenu-module-scss-module__A1C2Vq__FeatureCard--wide",
  "FeatureCardWideGroup": "MegaMenu-module-scss-module__A1C2Vq__FeatureCardWideGroup",
  "FeaturedLinksPanel": "MegaMenu-module-scss-module__A1C2Vq__FeaturedLinksPanel",
  "FeaturedLinksPanelLink": "MegaMenu-module-scss-module__A1C2Vq__FeaturedLinksPanelLink",
  "FeaturedLinksPanelList": "MegaMenu-module-scss-module__A1C2Vq__FeaturedLinksPanelList",
  "FeaturedLinksPanelListBottom": "MegaMenu-module-scss-module__A1C2Vq__FeaturedLinksPanelListBottom",
  "FeaturedLinksPanelRight": "MegaMenu-module-scss-module__A1C2Vq__FeaturedLinksPanelRight",
  "FeaturedLinksPanelTitle": "MegaMenu-module-scss-module__A1C2Vq__FeaturedLinksPanelTitle",
  "List": "MegaMenu-module-scss-module__A1C2Vq__List",
  "MainTitleLink": "MegaMenu-module-scss-module__A1C2Vq__MainTitleLink",
  "Popup": "MegaMenu-module-scss-module__A1C2Vq__Popup",
  "Positioner": "MegaMenu-module-scss-module__A1C2Vq__Positioner",
  "Root": "MegaMenu-module-scss-module__A1C2Vq__Root",
  "Title": "MegaMenu-module-scss-module__A1C2Vq__Title",
  "TopBrandIconImage": "MegaMenu-module-scss-module__A1C2Vq__TopBrandIconImage",
  "TopBrandIconItem": "MegaMenu-module-scss-module__A1C2Vq__TopBrandIconItem",
  "TopBrandIcons": "MegaMenu-module-scss-module__A1C2Vq__TopBrandIcons",
  "TopBrandIconsGrid": "MegaMenu-module-scss-module__A1C2Vq__TopBrandIconsGrid",
  "TopBrandIconsTitle": "MegaMenu-module-scss-module__A1C2Vq__TopBrandIconsTitle",
  "Trigger": "MegaMenu-module-scss-module__A1C2Vq__Trigger",
  "Trigger--highlight": "MegaMenu-module-scss-module__A1C2Vq__Trigger--highlight",
  "Viewport": "MegaMenu-module-scss-module__A1C2Vq__Viewport",
  "ViewportWrapper": "MegaMenu-module-scss-module__A1C2Vq__ViewportWrapper",
});
